import React, { useState, useEffect } from "react";
import "./taskscreated.scss";
import Pagination from "react-bootstrap/Pagination";
import { Accordion, OverlayTrigger, Tooltip } from "react-bootstrap";
import Navbar from "../landing/header/Navbar";
import axios from "axios";
import { API_URL } from "../../utils/ApiUrl";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import moment from "moment";
import { Link } from "react-router-dom";
import Loader from "../../hooks/loader";
import Environment from "../../utils/Environment";
import TaskStatus from "./TaskStatus";
import ParticipatedTimer from "./ParticipatedTimer";
import ActionButton from "./ActionButton";
import ActionButtonMobile from "./ActionButtonMobile";
import ConditionalLink from "../../helper/Components/ConditionalLink";
import { intitial_production_eth_id } from "../../constants/id";
const Taskscreated = () => {
  const [loader, setLoader] = useState(false);
  const [pages, setPages] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [arry, setArry] = useState([]);
  const handlePageChange = (e) => {
    // console.log("called");
    const selectedPage = e.selected;
    setPage(selectedPage);
  };

  const getProfile = async () => {
    let accessToken = localStorage.getItem("accessToken");
    setLoader(true);
    var config = {
      method: "get",
      url: `${API_URL}tasks/my?limit=${5}&offset=${page + 1}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // Include the access token here
      },
    };
    try {
      let response = await axios(config);

      if (response) {
        let vale = response?.data?.data;
        // console?.log('Task created successfully:', response?.data?.data);
        setPageCount(vale?.count / 5);
        setPages(vale?.pages);
        setArry(vale?.tasks);
        setLoader(false);
      }
    } catch (error) {
      console.error("Error occurred while creating task:", error);
      setLoader(false);
      // toast.error(error?.message);
    }
  };

  useEffect(() => {
    getProfile();
  }, [page]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip " className="tolltipssss" {...props}>
      The task is active on the website and accepting participants. The due date
      has not yet passed.
    </Tooltip>
  );
  return (
    <>
      {loader && <Loader />}
      {/* <Navbar /> */}
      <section className="taskscreated">
        <img
          src="/assets/importantassets/backshade.png"
          alt="backshade"
          className="backshade"
        />
        <img
          src="/assets/importantassets/backshadembl.png"
          alt="backshade"
          className="backshadembl d-none"
        />
        <div className="custom-container">
          <p className="toppara">
            <span className="light">Home </span>/ Tasks I Created
          </p>
          <h2 className="createdhead">Tasks I Created</h2>
          <div className="createdtasktable">
            {arry.length > 0 ? (
              <table>
                <thead>
                  <th>Task Name</th>
                  <th>Reward</th>

                  <th>Transaction Hash</th>
                  <th>Participants</th>
                  <th>Submissions</th>
                  <th>Status</th>
                  <th>Ends in</th>
                  <th>Action</th>
                </thead>
                <tbody>
                  {arry?.map((e) => {
                    const targetDate = moment(e?.endTime);
                    const currentDate = moment();
                    const duration = moment.duration(
                      targetDate.diff(currentDate)
                    );
                    let status = "";
                    const formattedDuration = `${Math.floor(
                      duration.asDays()
                    )}d ${duration.hours()}h ${duration.minutes()}m ${duration.seconds()}s`;
                    const currentEpochSeconds = Math.floor(Date.now() / 1000);
                    const date = new Date(e?.endTime);
                    const epochSeconds = Math.floor(date.getTime() / 1000);
                    const participant = e?.participantCount;
                    // // console.log(currentEpochSeconds < epochSeconds,e.status,'currentEpochSeconds < epochSeconds&&e.status == "inProgress"');
                    if (
                      currentEpochSeconds < epochSeconds &&
                      e.status == "inProgress"
                    ) {
                      status = "In Progress";
                    } else if (
                      currentEpochSeconds > epochSeconds &&
                      e.status == "inProgress"
                    ) {
                      status = "In Review";
                    } else if (
                      currentEpochSeconds > epochSeconds &&
                      e.status == "ended"
                    ) {
                      status = "Ended";
                    } else if (e?.status === "disputeResolved") {
                      status = "Dispute Resolved";
                    } else {
                      status = "indispute";
                    }

                    return (
                      <tr>
                        <td className="set-text-ellipses">
                          <ConditionalLink
                            data-toggle="tooltip"
                            data-placement="top"
                            title={e?.title}
                            href={`/tasksdetails/${e?.id}`}
                          >
                            {e?.title}
                          </ConditionalLink>
                        </td>
                        <td>
                          <p className="tablepara">
                            {e.reward} {e.currencySymbol}
                          </p>
                        </td>

                        <td>
                          <a
                            target="_blank"
                            href={`${e?.id > intitial_production_eth_id ? Environment?.trxHashUrl_Arb : Environment?.trxHashUrl}/tx/${e.taskTransactionHash}`}
                          >
                            {e?.taskTransactionHash?.slice(0, 5) +
                              "...." +
                              e?.taskTransactionHash?.slice(-5)}{" "}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill="none"
                            >
                              <path
                                d="M8.33333 4.66667H6.83333C5.89991 4.66667 5.43285 4.66667 5.07633 4.84832C4.76273 5.00811 4.50795 5.2629 4.34816 5.5765C4.1665 5.93302 4.1665 6.40008 4.1665 7.3335V13.6668C4.1665 14.6003 4.1665 15.0667 4.34816 15.4232C4.50795 15.7368 4.76273 15.9921 5.07633 16.1519C5.43251 16.3333 5.899 16.3333 6.83059 16.3333H13.1691C14.1007 16.3333 14.5665 16.3333 14.9227 16.1519C15.2363 15.9921 15.4919 15.7366 15.6517 15.423C15.8332 15.0668 15.8332 14.6008 15.8332 13.6692V12.1667M16.6665 8V3.83334M16.6665 3.83334H12.4998M16.6665 3.83334L10.8332 9.66667"
                                stroke="black"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </a>
                        </td>
                        <td>
                          <p className="tablepara">{e.participantCount}</p>
                        </td>
                        <td>
                          <p className="tablepara">{e?.submissionCount}</p>
                        </td>
                        <td>
                          {/* <p className="tablepara"><span className={status == "In Progress" ? "progressbtn" : status == "Ended" ? "endedbtn" :status=="In Review"? "reviewbtn":'disputedbtn'}>{status}</span>
                            </p> */}
                          <TaskStatus status={status} data={e} />
                          {/* <Status status={status} taskId={e?.contractTaskId} /> */}

                          {/* <button className='greenbuttontoltip'>Live   <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={renderTooltip}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z" fill="#3EDD1E" />
                              </svg>
                            </OverlayTrigger> </button> */}
                          {/* <button className='orangebuttontoltip'>In Dispute Period <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                              <path d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z" fill="#FF9500" />
                            </svg></button> */}
                          {/* <button className='lightbuttontoltip'>In Voting Period <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                              <path d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z" fill="#E2C624" />
                            </svg></button> */}
                          {/* <button className='completedtbuttontoltip'>Completed <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                              <path d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z" fill="#7B808A" />
                            </svg></button> */}
                        </td>
                        <td>
                          {/* <p className="tablepara"> {currentEpochSeconds <= epochSeconds && status !== "Ended" ? formattedDuration : " Time Ended"}</p> */}
                          <ParticipatedTimer
                            status={status}
                            data={e}
                            getProfile={getProfile}
                          />
                        </td>
                        <td>
                          <ActionButton taskData={e} />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <>
                <table>
                  <thead>
                    <th>Task Name</th>
                    <th>Reward</th>
                    <th>Ends in</th>
                    <th>Transaction Hash</th>
                    <th>Participants</th>
                    <th>Status</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan={6}>
                        {" "}
                        <h6 className="nodata-text">No Data Found!</h6>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </>
            )}
            <div className="paginationmain">
              {/* <div className="left-f">
          <h6>
                {" "}
                {count > 0 && count <= 5 ? (
                  <>
                    <p>
                      SHOWING 1-{count} OF {count}
                    </p>
                  </>
                ) : count > 5 ? (
                  <>
                    <p>
                      SHOWING {page > 0 ? page * 5 + 1 : page + 1} -
                      {5 * (page + 1) > count ? count : 5 * (page + 1)} OF{" "}
                      {count}
                    </p>
                  </>
                ) : (
                  <>
                    <p>SHOWING 0 OF 0</p>
                  </>
                )}
              </h6>
          </div> */}
              {pages > 1 && (
                <ReactPaginate
                  previousLabel={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <path
                        d="M10 13L5 8L10 3"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  }
                  nextLabel={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <path
                        d="M5 13L10 8L5 3"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  }
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  pageCount={pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageChange}
                  containerClassName="pagination"
                  activeClassName="active"
                  forcePage={page}
                ></ReactPaginate>
              )}
            </div>
          </div>
          <div className="createdtaskmbl d-none">
            <div className="acctop">
              <p className="taskpara">Task name</p>
              <p className="taskpara">Status</p>
            </div>
            {arry.map((e, i) => {
              const targetDate = moment(e?.endTime);
              const currentDate = moment();
              const duration = moment.duration(targetDate.diff(currentDate));
              let status = "";
              const formattedDuration = `${Math.floor(
                duration.asDays()
              )}d ${duration.hours()}h ${duration.minutes()}m ${duration.seconds()}s`;
              const currentEpochSeconds = Math.floor(Date.now() / 1000);
              const date = new Date(e?.endTime);
              const epochSeconds = Math.floor(date.getTime() / 1000);
              if (
                currentEpochSeconds < epochSeconds &&
                e.status == "inProgress"
              ) {
                status = "In Progress";
              } else if (
                currentEpochSeconds > epochSeconds &&
                e.status == "inProgress"
              ) {
                status = "In Review";
              } else if (
                currentEpochSeconds > epochSeconds &&
                e.status == "ended"
              ) {
                status = "Ended";
              } else if (e.status === "disputeResolved") {
                status = "Dispute Resolved";
              } else {
                status = "indispute";
              }
              return (
                <Accordion>
                  <Accordion.Item eventKey={i}>
                    <Accordion.Header>
                      <div className="taskmain">
                        <ConditionalLink
                          data-toggle="tooltip"
                          data-placement="top"
                          title={e?.title}
                          href={`/tasksdetails/${e?.id}`}
                        >
                          {e?.title.slice(0, 15)}
                        </ConditionalLink>
                      </div>

                      <div className="statusmain">
                        {/* <span className={status == "In Progress" ? "progressbtn" : status == "Ended" ? "endedbtn" : status == "In Review" ? "reviewbtn" : status == "Dispute Resolved" ? 'reviewbtn' : 'disputedbtn'}>{status}  <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={renderTooltip}
                            >
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
<path d="M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76537 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.70841C10.5891 7.90672 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM5.8125 3.375C5.92375 3.375 6.03251 3.40799 6.12501 3.4698C6.21751 3.53161 6.28961 3.61946 6.33218 3.72224C6.37476 3.82502 6.3859 3.93812 6.36419 4.04724C6.34249 4.15635 6.28892 4.25658 6.21025 4.33525C6.13158 4.41391 6.03136 4.46749 5.92224 4.48919C5.81313 4.5109 5.70003 4.49976 5.59724 4.45718C5.49446 4.41461 5.40661 4.34251 5.3448 4.25001C5.28299 4.15751 5.25 4.04875 5.25 3.9375C5.25 3.78832 5.30927 3.64524 5.41475 3.53975C5.52024 3.43426 5.66332 3.375 5.8125 3.375ZM6.375 8.625C6.17609 8.625 5.98532 8.54598 5.84467 8.40533C5.70402 8.26468 5.625 8.07391 5.625 7.875V6C5.52555 6 5.43016 5.96049 5.35984 5.89017C5.28951 5.81984 5.25 5.72446 5.25 5.625C5.25 5.52554 5.28951 5.43016 5.35984 5.35984C5.43016 5.28951 5.52555 5.25 5.625 5.25C5.82392 5.25 6.01468 5.32902 6.15533 5.46967C6.29598 5.61032 6.375 5.80109 6.375 6V7.875C6.47446 7.875 6.56984 7.91451 6.64017 7.98484C6.71049 8.05516 6.75 8.15054 6.75 8.25C6.75 8.34946 6.71049 8.44484 6.64017 8.51517C6.56984 8.58549 6.47446 8.625 6.375 8.625Z" fill="#4987E4"/>
</svg>
                            </OverlayTrigger> </span> */}
                        <TaskStatus status={status} data={e} />
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="mainacc">
                        <div className="inneracc">
                          <p className="leftacc">Ends in</p>
                          <p className="rightacc">
                            {/* {currentEpochSeconds <= epochSeconds &&
                            status !== "Ended"
                              ? formattedDuration
                              : " time Ended"} */}
                            <ParticipatedTimer
                              status={status}
                              data={e}
                              getProfile={getProfile}
                            />
                          </p>
                        </div>
                        <div className="inneracc">
                          <p className="leftacc">Reward</p>
                          <p className="rightacc">
                            {e.reward} {e.currencySymbol}
                          </p>
                        </div>
                        <div className="inneracc">
                          <p className="leftacc">Transaction Hash</p>
                          <p className="rightacc">
                            <a
                              target="_blank"
                              href={`${e?.id > intitial_production_eth_id ? Environment?.trxHashUrl_Arb : Environment?.trxHashUrl}/tx/${e.taskTransactionHash}`}
                            >
                              {" "}
                              {`${e?.taskTransactionHash?.slice(0, 5)}...${e?.taskTransactionHash?.slice(-3)}`}&nbsp;
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="16"
                                viewBox="0 0 15 16"
                                fill="none"
                              >
                                <path
                                  d="M8.75 2.55771H13.125V6.93271M13.125 9.89333V12.8702C13.125 13.1188 13.0262 13.3573 12.8504 13.5331C12.6746 13.7089 12.4361 13.8077 12.1875 13.8077H2.8125C2.56386 13.8077 2.3254 13.7089 2.14959 13.5331C1.97377 13.3573 1.875 13.1188 1.875 12.8702V3.49521C1.875 3.24657 1.97377 3.00811 2.14959 2.8323C2.3254 2.65648 2.56386 2.55771 2.8125 2.55771H5.625M8.0625 7.62021L12.8437 2.83896"
                                  stroke="#627F97"
                                  stroke-width="1.25"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </a>
                          </p>
                        </div>
                        <div className="inneracc">
                          <p className="leftacc">Participants</p>
                          <p className="rightacc">{e.participantCount}</p>
                        </div>
                        <div className="inneracc">
                          <p className="leftacc">Submissions</p>
                          <p className="rightacc">{e?.submissionCount}</p>
                        </div>

                        {/* <button className='tasksubmit'>Review</button> */}
                        <ActionButtonMobile taskData={e} />
                        {/* <button className='tasksubmitred'></button> */}
                        {/* <button className='tasksubmitwithdraw'>Claim Refund</button> */}
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              );
            })}

            <div className="paginationmain">
              {pages > 1 && (
                <ReactPaginate
                  previousLabel={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <path
                        d="M10 13L5 8L10 3"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  }
                  nextLabel={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                    >
                      <path
                        d="M5 13L10 8L5 3"
                        stroke="#fff"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  }
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  pageCount={pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageChange}
                  containerClassName="pagination"
                  activeClassName="active"
                  forcePage={page}
                ></ReactPaginate>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Taskscreated;
